import Parse from "parse";

import type { Media } from "./Media";
import type { Schedule_Template } from "./Schedule_Template";
import type { _User } from "./_User";

type OD3_Source = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface Schedule_ExecutionAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description?: string;
  finishedAt?: Date;
  material?: any[];
  media: Parse.Relation<Schedule_Execution, Media>;
  origin?: Schedule_Template;
  origin_cron?: any;
  source?: OD3_Source;
  tenant?: OD3_Tenant;
  title?: string;
  user: _User;
}

export class Schedule_Execution extends Parse.Object<Schedule_ExecutionAttributes> {
  static className: string = "OD3_Maintenance_Schedule_Execution";

  constructor(data?: Partial<Schedule_ExecutionAttributes>) {
    super("OD3_Maintenance_Schedule_Execution", data as Schedule_ExecutionAttributes);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get finishedAt(): Date | undefined {
    return super.get("finishedAt");
  }
  set finishedAt(value: Date | undefined) {
    super.set("finishedAt", value);
  }
  get material(): any[] | undefined {
    return super.get("material");
  }
  set material(value: any[] | undefined) {
    super.set("material", value);
  }
  get media(): Parse.Relation<Schedule_Execution, Media> {
    return super.relation("media");
  }
  get origin(): Schedule_Template | undefined {
    return super.get("origin");
  }
  set origin(value: Schedule_Template | undefined) {
    super.set("origin", value);
  }
  get origin_cron(): any | undefined {
    return super.get("origin_cron");
  }
  set origin_cron(value: any | undefined) {
    super.set("origin_cron", value);
  }
  get source(): OD3_Source | undefined {
    return super.get("source");
  }
  set source(value: OD3_Source | undefined) {
    super.set("source", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
  get user(): _User {
    return super.get("user");
  }
  set user(value: _User) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Schedule_Execution", Schedule_Execution);
